import { Routes, RouterModule }  from '@angular/router';

import { RequestsComponent } from './requests.component';
import { RequestAddComponent } from './create/request_add.component';
import { RequestReturnComponent } from './return/return.component';
import { RequestConfirmComponent } from './confirm/confirm.component';
export const RequestsRoutes: Routes = [
    {
        path: '',
        component: RequestsComponent,
        children: [
            { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
            { path: 'create', component: RequestAddComponent },
            { path: 'return', component: RequestReturnComponent },
            { path: 'confirm', component: RequestConfirmComponent },
            { path: 'create/:id', component: RequestAddComponent },
            { path: 'return/:id', component: RequestReturnComponent },
            { path: 'confirm/:id', component: RequestConfirmComponent }
        ]
    }
];

export const RequestsRoutingModule = RouterModule.forChild(RequestsRoutes);



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/request-mgmt/requests-routing.module.ts